import { Button } from "@mui/material";

import { GridItem, GridRow } from "commons/ui/Grid";

import SpecialOfferForm from "components/form/SpecialOfferForm";

import { SaveContextProvider } from "context/save";

import useSaveUpdateWithSnackbar from "hooks/useSaveUpdateWithSnackbar";

function ButtonSave() {
    const { onButtonClick } = useSaveUpdateWithSnackbar({
        successMsg: "Offerta speciale modificata con successo",
        errorMsg: "Errore nella modifica dell'offerta speciale",
        navigateTo: { link: "/offerte-speciali" },
    });

    return (
        <GridRow justifyContent={"right"}>
            <GridItem className={"button-under-paper"}>
                <Button variant={"contained"} onClick={onButtonClick}>
                    Salva
                </Button>
            </GridItem>
        </GridRow>
    );
}

function ModificaOffertaSpeciale() {
    return (
        <>
            <GridRow className={"title-top-paper"}>
                <GridItem>
                    <h1>Modifica Offerta Speciale</h1>
                </GridItem>
            </GridRow>

            <SaveContextProvider>
                <SpecialOfferForm />

                <ButtonSave />
            </SaveContextProvider>
        </>
    );
}

export default ModificaOffertaSpeciale;
